export enum PaymentOption {
  CreditCard = "카드"
}
